import $ from "jquery";
import { setResponsiveImage, getImageByContentId } from "#scripts/images";
import { getNews, setNewsList } from "#scripts/news";
import { createNanoId, truncateWithElipsis } from "#scripts/general_functions";
import language from "#scripts/translation";

export const newslistFront = (maxItems, moduleTitle, moduleMoreText, bgColor = "") => {
	let more = "";
	let content = "";

	getNews(maxItems, 0, (data) => {
		let news = [];

		if (data.totalCount > 0) {
			data.listOfContent.forEach((item, index) => {
				if (index === Number.parseInt(maxItems)) {
					return;
				}
				const meta = JSON.parse(decodeURIComponent(item.metaObject));

				if (
					meta.imageContentId &&
					window.serverdata.configMeta.aim.showNewsImages
				) {
					const newsGuid = createNanoId();
					let image = "";

					image = `<img src='' id='news__${newsGuid}' class="news__image" desc="${meta.imageDescription}" alt="${meta.imageDescription}">`;
					getImageByContentId(meta.imageContentId, (img) => {
						$(`#news__${newsGuid}`).attr({
							"data-src": img.url,
							src: "/images/transparent.png",
							"data-imagemode": "fill",
						});
						if (
							img.imageHotspotX !== undefined &&
							img.imageHotspotY !== undefined
						) {
							$(`#news__${newsGuid}`).attr({
								"data-imagehotspot": `${img.imageHotspotX},${img.imageHotspotY}`,
							});
						}
						setResponsiveImage($(`#news__${newsGuid}`));
					});


					news.push(`
                  <div class="news__item">
                    <a href="/nyhet/${item.contentId}">
                      <div class="news__image_container">
                        ${image}
                      </div>
                      <div class="news__item__content">
                        <span class="news__item__title">${item.title}</span>
                        <p class="news__item__intro">${truncateWithElipsis(
						item.intro,
						170,
					)}</p>        
                      </div>
                    </a>
                  </div>`);
				} else {
					news.push(`
                    <div class="news__item">
                      <div class="news__item__content">
                        <a href="/nyhet/${item.contentId}" class="news__item__title">
                            ${item.title}
                            <p class="news__item__intro">${truncateWithElipsis(
						item.intro,
						170,
					)}</p>
                        </a>
                      </div>
                    </div>`);
				}
			});
			news = news.join("");

			if (data.totalCount > maxItems) {
				more = `<a href="/liste/nyheter" class="news__more__link">
									${moduleMoreText !== "" ? moduleMoreText : language("NEWS_SEEALL")} <span class="material-icons-outlined notranslate news__more__icon">&#xE5C8;</span>
								</a>`;
			}
			const extraStyle = bgColor?.trim?.()
				? `--current_news_color: ${bgColor}; background-color: ${bgColor};`
				: '';
			content = `
            <div class="news" style="${extraStyle}">
                <div class="container p-0">
                    <div class="row">
                        <div class="col"><h2 class="news__title">${moduleTitle !== ""
					? moduleTitle
					: language("START_NEWSHEADER")
				}</h2></div>
                    </div>
                    <div class="row news__list">
                        ${news}
                    </div>
                    <div class="row">
                        <div class="col text-right">
                            <div class="news__more__container">
                                ${more}
                            </div>
                        </div>
                    </div>
                </div>
            </div>`;

			$("#newslist__frontpage").html(content);
		}
	});

	return `<div id="newslist__frontpage" class="module__newslist${bgColor !== "" ? ' background' : ''}"></div>`;
};

export const newspage = () => {
	const list = setNewsList();
	return `
        <div class="newslist__page" id="newslistcontainer">
            ${list}
        </div>`;
};
